import React from "react";
import "../style/Regulation.css";

const Regulation = () => {
  return (
    <div className="regulation-container">

        <div id="reg-head" className="white-header">
            <h2>Licences, Regulation and<br/>
            Professional Memberships</h2>
            <p>As a strong proponent of transparency, we establish the highest
                <br/><br/>standards of safety for our clients' funds. For this reason, client funds
            <br/><br/>are kept in major international banks and are fully segregated from the
            <br/><br/>company’s own funds.</p>
      </div>


        <div className="regtext">
      <div className="regulation-cards">
        <div className="regulation-card">
        <img id="regimg" src="/images/reg4.png"alt="step1"/><br/><br/>
          <p id="regpara"><b>Financial Services Authority  (FSA)</b></p><hr/>
          <p>FSA is the autonomous regulatory body responsible to license, regulate, enforce regulatory and compliance requirements, monitor and supervise the conduct of business in the non-bank financial services sector in Seychelles.</p>
          <p>Extrede LLC is a Securities Dealer authorized and regulated by the Seychelles Financial Services Authority (FSA) with license number SE0389.</p>
          <p>Extrede LLC operates under this website for the provision of services to selected jurisdictions outside the European Economic Area (EEA).</p>
        </div>
        <div className="regulation-card">
        <img id="regimg" src="/images/reg2.png"alt="step1"/><br/><br/>
          <p id="regpara"><b>Central Bank of Curaçao and Sint Maarten (CBCS)</b></p>
          <hr/>
          <p>Extrede B.V. is a Securities Intermediary authorized and regulated by the Central Bank of Curaçao and Sint Maarten with license number 0002ION.</p>
          <p>The Central Bank of Curaçao and Sint Maarten supervises the financial sector of the countries Curaçao and Sint Maarten to primarily promote the stability, integrity, efficiency, safety, and soundness of this sector.</p>
          <p>Extrede B.V. operates under this website for the provision of services to selected jurisdictions outside the European Economic Area (EEA).</p>
        </div>
        <div className="regulation-card">
        <img id="regimg" src="/images/reg11.png"alt="step1"/><br/><br/>
          <p id="regpara"><b>Financial Services Commission (FSC)</b></p>
          <hr/>
          <p>Extrede (VG) LLC is authorized by the Financial Services Commission (FSC) in BVI with registration number 2032226 and investment business license number SIBA/M/12/10344.</p>
          <p>The FSC is the Regulatory Authority responsible for all financial services business operating in and from within the BVI.</p>
          <p>Extrede (VG) LLC operates under this website for the provision of services to selected jurisdictions outside the European Economic Area (EEA).</p>
        </div>

        <div className="regulation-card">
        <img id="regimg" src="/images/reg5.png"alt="step1"/><br/><br/>
          <p id="regpara"><b>Cyprus Securities and Exchange Commission (CySEC)</b></p>
          <hr/>
          <p>CySEC is the independent public supervisory authority responsible for the supervision of, inter alia, the investment services in Cyprus. Extrede (Cy) LLC is a Cyprus Investment Firm, authorized and regulated by the Cyprus Securities and Exchange Commission (CySEC) with license number 182/015.</p>
          <p>Extrede (Cy) LLC operates under the website www.oslocapitalllc.eu. Extrede(Cy) LLC does not offer services to retail clients.</p>
         </div>

        <div className="regulation-card">
        <img id="regimg" src="/images/reg6.png"alt="step1"/><br/><br/>
          <p id="regpara"><b>Capital Markets Authority (CMA)</b></p>
          <hr/>
          <p>

            Capital Markets Authority (CMA)
            Extrede (KE) LLC is authorized by the Capital Markets Authority (CMA) in Kenya as a non-dealing online foreign exchange broker with license number 1081.</p>
            <p>The CMA is a governmental regulating body charged with the prime responsibility of supervising, licensing and monitoring the activities of market intermediaries, and all other persons licensed under the Capital Markets Act.</p>
            <p>Extrede (KE) LLC operates under the website www.oslocapitals.ke</p>
        </div>
        <div className="regulation-card">

        <img id="regimg" src="/images/reg3.png"alt="step1"/><br/><br/>
          <p id="regpara"><b>Jordan Securities Commission (JSC)</b></p>
          <hr/>
            <p>JSC is the regulatory body responsible to license, regulate, enforce regulatory and compliance requirements, monitor and supervise the conduct of business in the non-bank financial services sector in the Hashemite Kingdom of Jordan.</p>
            <p>Extrede Jordan LLC is registered with the Companies Control Department with a registeration No. (60191) and regulated by the Jordan Securities Commission (JSC).</p>
            <p>Extrede Jordan LLC operates under the website www.oslocapitals.jo.</p>
         </div>
          </div>
          <br/><br/><br/>
          <strong>Regional restrictions</strong>
         <p id="regpara11">Extrede does not provide services to residents of several jurisdictions, including the USA.</p>
     
      </div>

     

      <div className="regulation-platform-protection">
        <h2>Platform protection</h2>
        <p>Learn more about our safe and secure trading conditions and protection measures for a smooth trading experience.</p>
        <div className="regulation-protection-cards">
          <div className="regulation-protection-card">
            <div className="reg-img-text">
                <div className="reg-img">
                <img  src="/images/regss1.png"alt="step1"/>

                </div>
                <div className="reg-text1">
                <h3  id="regpara">Web attack protection</h3>
                <p id="regtext11">Our Web Application Firewall (WAF) protects our infrastructure and servers from web threats like SQL injection, XSS attacks, and blocks harmful traffic</p>
                </div>
            </div>
            
          </div>
          <div className="regulation-protection-card">
          <div className="reg-img-text">
                <div className="reg-img">
                <img  src="/images/regss2.png"alt="step1"/>

                </div>
                <div className="reg-text1">
            <h3  id="regpara">Trading platform fault tolerance</h3>
            <p id="regtext11">Our DDoS protection offers you seamless order execution, 24/7 access to your Personal Area, swift deposits and withdrawals, and uninterrupted servers’ operations.</p>
          </div>
          </div>
          </div>
          <div className="regulation-protection-card">
          <div className="reg-img-text">
                <div className="reg-img">
                <img  src="/images/regss3.png"alt="step1"/>

                </div>
                <div className="reg-text1">
            <h3  id="regpara">Zero trust approach</h3>
            <p id="regtext11">Our Zero Trust model assumes minimal trust for company IT components and includes features like user and device authentication, restricted access, and network monitoring.</p>
            </div>
          </div>
          </div>
          <div className="regulation-protection-card">
          <div className="reg-img-text">
                <div className="reg-img">
                <img  src="/images/regss4.png"alt="step1"/>

                </div>
                <div className="reg-text1">
            <h3  id="regpara">Cybersecurity knowledge and skills</h3>
            <p id="regtext11">Our Information Security Team are continuously updated on security technology and upgrade their skills through workshops and certifications</p>
          </div>
          </div>
          </div>
        </div>
      </div>

      <h1 id="payment">Payment protection</h1>
    <p id="payment">Read about our various premium payment security features to protect your payment transactions.</p>
    
          <div id="regimg1" className="imgtext">

      
        

        <div  id="text" className="text">
          {/* <p id="p">You are safe with us.</p> */}
          
          <h1  className="h1">Seamless withdrawals
          </h1 >
          <p>Our automatic withdrawal feature ensures that we process your withdrawal requests instantly, giving you access to your funds even on weekends. Promptness of payment depends on your selected payment method.</p>
          <br/>
          <h1  className="h1">Segregated accounts</h1>
          <p>We safeguard your funds by holding them segregated from our own. Our funds are always larger, so we can meet your withdrawal needs any time of the day.</p>
          <br/>
          <h1 className="h1">3D Secure verification</h1>
          <p>We ensure secure trading with 3D Secure debit card transactions, offering extra fraud protection through a one-time pin sent to your phone</p>
          <br/>
          {/* <h1 className="h1">PCI DSS compliance</h1>
          <p>We're fully audited, adhering to all PCI DSS needs, ensuring card data security through effective management, custom security settings, and regular vulnerability scans</p> */}

          </div>

          <div className="img1">
          <img src="/images/regimg.png" alt="girl"/>
            </div>

          </div>

            <div className="reg-text-head">
          <h1>Trading protection</h1>
          <p>Shield your strategy with our bespoke trading protection features.</p>
          </div>
          <div id="best1" className="basic-img">
          <img src="/images/regbg.png" alt="Trading Platform" />
          </div>

          <br/><br/><br/><br/>
          {/* Negative Balance Protection */}
      <div id="neg" className="neg">
      <section className="negative-balance-protection">
        <h2>Negative Balance Protection</h2>
        {/* <p>We ensure that traders cannot lose more than their available balance.</p> */}
      <p>Trade confidently knowing you won’t owe your broker money; we prevent losses from exceeding your balance across all trading account types.</p>
      </section>

      {/* Stop Out Protection */}
      <section className="negative-balance-protection">
        <h2>Stop Out Protection</h2>
        {/* <p>Our stop-out mechanism ensures that you do not experience excessive losses.</p> */}
      <p>Enjoy this unique secure trading protection feature that strengthens your positions and helps delay or avoid stop outs, particularly </p>
      </section>

      </div>

      <br/><br/><br/><br/>

      {/* Protection Steps */}
      <section className="protection-steps">
        <h2>Take Steps to Protect Yourself</h2>
        <div id="step" className="step">
            <div className="step1img">
                <img id="step1img" src="/images/images.png"alt="step1"/>

            </div>
            <div className="step1text">
                <p>Keep your Personal Area private, never share access and personal documents. Don't let anyone use your name to create an Extrede account or share your security information.</p>
            </div>
        </div>
      </section>
      <br/><br/>
      <br/><br/>
      
        <div id="step" className="step">
            <div className="step1img">
                <img id="step1img" src="/images/images_2.png"alt="step1"/>

            </div>
            <div className="step1text">
                {/* <p>Keep your Personal Area private, never share access and personal documents. Don't let anyone use your name to create an Extrede account or share your security information.</p> */}
                <p>Only conduct financial activities within the Extrede Personal Area and avoid transferring funds to unknown accounts.</p>
            </div>
        </div>
    </div>
  );
};

export default Regulation;
